import styled from "styled-components";

const TemplatesPageTitleStyled = styled.div`
display:flex;
align-items: center;

h3{
    margin-bottom:0;
    display: inline-block;
}
    > :first-child{
        flex:1;
        button{
            margin-left:10px;
        }
    }

    > div:nth-child(2) div{
        transition:width 200ms cubic-bezier(0, 0.78, 0.58, 1);
    }
`;

export {
    TemplatesPageTitleStyled,

};